'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var counter = 1;
function generateId() {
    return 'opener_' + counter++;
}

var Opener = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Opener, _React$PureComponent);

    function Opener() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Opener);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Opener.__proto__ || (0, _getPrototypeOf2.default)(Opener)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
            var _this$props$canCollap = _this.props.canCollapse,
                canCollapse = _this$props$canCollap === undefined ? true : _this$props$canCollap;

            if (canCollapse) {
                _this.props.onChange(e);

                // force reinit sticky
                if (!(0, _linksoftAlbatros.isMaxWidth)('md')) {
                    setTimeout(function () {
                        $('html, body').animate({
                            scrollTop: '-=10'
                        }, 200);
                    }, 0);
                }
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Opener, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                icon = _props.icon,
                open = _props.open,
                onChange = _props.onChange,
                _props$canCollapse = _props.canCollapse,
                canCollapse = _props$canCollapse === undefined ? true : _props$canCollapse;

            var id = generateId();
            var inputProps = { id: id };
            var isOpen = !canCollapse || open || false;
            if (typeof onChange === 'function') {
                inputProps.onChange = this.handleChange;
                inputProps.checked = isOpen;
            } else {
                inputProps.defaultChecked = isOpen;
            }
            if (!canCollapse) {
                inputProps.readOnly = true;
            }
            return _react2.default.createElement(
                'div',
                { className: 'opener' },
                _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox' }, inputProps)),
                _react2.default.createElement(
                    'label',
                    { className: 'opener__trigger', htmlFor: id },
                    !!icon && _react2.default.createElement('i', { className: icon }),
                    ' ',
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'opener__content' },
                    this.props.children
                )
            );
        }
    }]);
    return Opener;
}(_react2.default.PureComponent), _class.propTypes = {
    title: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    open: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    canCollapse: _propTypes2.default.bool
}, _temp2);
exports.default = Opener;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/Opener.js
// module id = 750
// module chunks = 0